import { Routes } from '@angular/router';
import { CountTabComponent } from './count-tab/count-tab.component';
export const USER_COUNT_ROUTES: Routes = [
    { path: '', component: CountTabComponent },
];
